<template>
  <div class="dialpad">
    <div class="dialpad-icon">
      <el-button :class="{'active':dialpadVisible}" icon="el-icon-mobile" circle @click="handleOpenDialpad"></el-button>
    </div>
    <el-dialog :visible.sync="dialpadVisible" title="拨号" :before-close="handleClose" width="242px" :modal="false" :lock-scroll="false" :modal-append-to-body="false" v-dialpad-drag>
      <el-row class="mb-10">
        <el-col :span="24">
          <el-input v-model="phoneNum" size="medium"></el-input>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum(1)">1</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(2)">2</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(3)">3</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum(4)">4</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(5)">5</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(6)">6</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum(7)">7</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(8)">8</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(9)">9</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="clickNum('*')">*</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum(0)">0</div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="clickNum('#')">#</div>
        </el-col>
      </el-row>
      <el-row class="num-cell">
        <el-col :span="8">
          <div class="num" @click="record"><i class="el-icon-s-grid"></i></div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="call"><i class="el-icon-phone-outline"></i></div>
        </el-col>
        <el-col :span="8">
          <div class="num" @click="backNum"><i class="el-icon-back"></i></div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import BenzAMRRecorder from 'benz-amr-recorder'
var amr = new BenzAMRRecorder()
export default {
  name: 'Dialpad',
  data () {
    return {
      dialpadVisible: false,
      phoneNum: '',
      wavSrc: '/static/13685.wav',
      wavPlayIng: false
    }
  },
  computed: {},
  watch: {
    phoneNum (val) {
      this.phoneNum = this.phoneNum.replace(/[^\d*#/]/g, '')
    }
  },
  methods: {
    handleOpenDialpad () {
      this.dialpadVisible = !this.dialpadVisible
    },
    handleClose (done) {
      this.phoneNum = ''
      done()
    },
    clickNum (num) {
      this.phoneNum += num

      let that = this
      if (!that.wavPlayIng) {
        that.wavPlayIng = true
        amr = new BenzAMRRecorder()
        amr.initWithUrl(this.wavSrc).then(function () {
          amr.play()
        })
        amr.onEnded(function () {
          that.wavPlayIng = false
          console.log('播放完毕')
        })
      }
    },
    record () {
      this.$message.success('录音自动开启，无需手动操作')
    },
    call () {
      let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if (!regPhone.test(this.phoneNum)) {
        this.$message.error('手机号格式错误')
        return
      }

      this.$axios.post('/api/admin/call_logs/' + this.phoneNum)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success('调用成功，请注意接听来电')
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    backNum () {
      this.phoneNum = this.phoneNum.slice(0, this.phoneNum.length - 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .dialpad >>> .el-dialog__wrapper
    width: 245px
    height: 410px
    // overflow: unset
    // position: unset !important
  .dialpad >>> .el-dialog__header
    padding: 4px 8px 4px 8px !important
    background-color: rgba(243, 244, 246, 1)
  .dialpad >>> .el-dialog__title
    font-size: 80%
  .dialpad >>> .el-dialog__headerbtn
    top: 5px !important
  .dialpad >>> .el-dialog__body
    padding: 15px
  .dialpad >>> .el-dialog
    margin-bottom: 0 !important
    position: fixed
    left: 40%
    z-index: inherit
  .dialpad-icon
    position: fixed
    right: .4rem
    bottom: .9rem
    z-index: 999999
    .el-button:focus, .el-button:active
      background-color: unset
  .active
    color: #3a8ee6
    border-color: #3a8ee6
  .mb-10
    margin-bottom: .2rem
  .num-cell
    padding: .2rem 0
    text-align: center
    .num
      width: .8rem
      height: .8rem
      text-align: center
      line-height: .8rem
      border-radius: 50%
      background-color: #f3f4f6
      box-shadow: 0px 1px 5px #888888
      display: inline-block
      cursor: pointer
      user-select: none
    .num:active
      background-color: #409eff
      color: #FFF
      box-shadow: inset 0 3px 5px rgba(0,0,0,.125)
</style>



// WEBPACK FOOTER //
// src/common/Dialpad.vue